import React, { useEffect, useState, useRef } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import toast from "react-hot-toast";
import SecondaryButton from "../../components/SecondaryButton";
import { signInWithEmailAndPassword } from "firebase/auth";
import PageHeader from "../../components/PageHeader";
import InputField from "../../components/InputField";
import { auth } from "../../config/firebaseConfig";
import { BsEye } from "react-icons/bs";
import PasswordInputField from "../../components/PasswordField";
import axiosInstance from "../../utils/axiosInstance";
import { fetchMyUserDetails, imageBaseUrl, registerUser, updateUserDetais } from "../../constants/ApiConstants";
import { Link, redirect, useNavigate } from "react-router-dom";
import SelectField from "../../components/SelectField";
import SelectField2 from "../../components/SelectField2";
import { countries } from "../../utils/countries";
import MobileNumberWithCountryCode from "../../components/MobileNumberWithCountryCode";
import DatePicker from "react-datepicker";
import { getYYYYmmddFromDate } from "../../utils/utils";
import { updateUserData } from "../../store/appSlice";
import { BiSolidMessageSquareEdit } from "react-icons/bi";
import FullPageLoader from "../../components/FullPageLoader";
import CommonMobileHeader from "../../components/Header/CommonMobileHeader";

export default function EditProfile() {
  pageTitle("Edit Profile ");

  const [loading, setLoading] = useState(false);
  const userData = useSelector((state) => state.appSlice.userData);
  const [email, setEmail] = useState("testusm");
  const [password, setPassword] = useState("12345");
  const [fullname, setFullname] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedPhoneCountry, setSelectedPhoneCountry] = useState("");
  const [gender, setGender] = useState(1);
  const [mobile, setMobile] = useState("");
  const [dob, setDob] = useState(new Date());
  const [profileImage, setProfileImage] = useState();
  const fileRef = useRef();
  const [submitting, setSubmitting] = useState(false);
  const [selectedFile, setSelectedFile] = useState();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchAndSetUserDetail();
  }, []);

  const fetchAndSetUserDetail = () => {
    setLoading(true);
    axiosInstance
      .post(fetchMyUserDetails, { user_id: userData?.id })
      .then((res) => {
        if (res?.data?.data?.profile_image) {
          setProfileImage(imageBaseUrl + res.data?.data?.profile_image);
        }
        setFullname(res.data?.data?.fullname);
        setEmail(res.data?.data?.identity);
        setDob(new Date(res.data?.data?.dob));
        setGender(res?.data?.data?.gender);
        setMobile(res?.data?.data?.phone_number.split(" ")[0]);
        setSelectedCountry(res?.data?.data?.country_code);
        setSelectedPhoneCountry(res?.data?.data?.phone_number.split(" ")[1]);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const mapCountries = countries.map((it) => ({ label: it.country_name, value: it.phone_code }));

  const onSelectCountryItem = (c) => {
    setSelectedCountry(c);
  };

  const handleSubmitClick = async () => {
    if (mobile === "") {
      toast.error("Mobile number is required");
      return;
    }
    if (!selectedCountry) {
      toast.error("Country is required");
      return;
    }
    if (!dob) {
      toast.error("Date of birth is required");
      return;
    }
    if (mobile !== "" && mobile.length < 8) {
      toast.error("Invalid mobile number");
      return;
    }

    const formData = new FormData();
    formData.append("identity", userData.identity);
    formData.append("phone_number", `${mobile} ${selectedPhoneCountry}`);
    formData.append("country_code", selectedCountry);
    formData.append("gender", gender);
    formData.append("dob", getYYYYmmddFromDate(dob));
    if (selectedFile && selectedFile instanceof File) {
      formData.append("profile_image", selectedFile);
    }

    try {
      setSubmitting(true);
      const response = await axiosInstance.post(updateUserDetais, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.data?.status) {
        toast.success("User details have been updated.");
        dispatch(updateUserData(response?.data?.data));
        console.log(response.data);
        navigate("/profile");
      } else {
        toast.error(response.data?.message);
      }
      setSubmitting(false);
    } catch (err) {
      console.log(err);
      setSubmitting(false);
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setSelectedFile(file);
        setProfileImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Wrapper>
      <Section topMd={0} topLg={0} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
        <div className="content-wrapper d-flex flex-column p-3 gap-1 justify-content-center align-items-center">
          <div className="col-md-4 row g-2">
            <CommonMobileHeader canBack title={"Edit Profile"} />
            {/* <img className="img-fluid w-25 h-25 m-3" src="/images/logo.svg" /> */}
            {loading && <FullPageLoader />}
            <p className="fs-md text-grey2 p-2"></p>
            <div className="position-relative">
              <input type="file" id="imageInput" accept="image/*" style={{ display: "none" }} className="position-absolute h-100 w-100" onChange={handleImageChange} />
              {
                <div className="" onClick={() => fileRef.current.click()} style={{ cursor: "pointer" }}>
                  {profileImage ? <img className="rounded w-25 h-25" src={profileImage} alt="Profile" /> : <img className="rounded bg-grey1 w-25 h-25" src={`/images/icons/ic_profile.png`} alt="Default Profile" style={{ objectFit: "cover" }} />}
                  <div className="position-absolute" style={{ left: "20%", top: "75%" }}>
                    <label htmlFor="imageInput">
                      <BiSolidMessageSquareEdit color="#000" style={{ cursor: "pointer" }} />
                    </label>
                    <input ref={fileRef} type="file" id="imageInput" accept="image/*" style={{ display: "none" }} onChange={handleImageChange} />
                  </div>
                </div>
              }
            </div>
            <MobileNumberWithCountryCode selectedPhoneCountry={selectedPhoneCountry} onChange={setSelectedPhoneCountry} mobile={mobile} onMobileChange={setMobile} />
            <SelectField2 defaultValue={selectedCountry} label={"Select Country"} placeholder={"Select a country"} items={mapCountries} onChange={onSelectCountryItem} />
            <SelectField
              defaultValue={gender}
              label={"Select Gender"}
              items={[
                { label: "Male", value: 1 },
                { label: "Female", value: 0 },
              ]}
              onChange={(e) => setGender(e.target.value)}
            />

            <div className="bg-transparent bg-grey2 position-relative w-100 mb-5">
              <span className="fs-normal text-muted mb-2 d-block">Date of Birth</span>
              <div className="position-relative w-100">
                <DatePicker className="bg-transparents" selected={dob} onChange={setDob} />
                <img className="position-absolute end-0" style={{ height: 15, width: 15, top: "26%", marginRight: 10 }} src="/images/icons/ic_calender.png" alt="calendar icon" />
              </div>
            </div>
            <SecondaryButton title={"Submit"} className={"mt-3"} onClick={handleSubmitClick} loading={loading} />
          </div>
        </div>
      </Section>
    </Wrapper>
  );
}
const Wrapper = styled.div``;
